export enum CategorySelectionMode {
  STANDARD,
  EMPTY_NOT_ALLOWED,
  ONLY_ONE_ALLOWED
}